import { inject, Injectable } from '@angular/core'
import BaseService from '@ui/Services/BaseService'
import User from '@client/User'
import { createUser } from '@client/utils'
import { Meta } from '@angular/platform-browser'

@Injectable()
export class UsersService extends BaseService<User> {
	public filterable: User

	protected endpoint = '/api/users'

	private readonly meta: Meta

	constructor() {
		super()
		this.meta = inject(Meta)
		this.filterable = createUser()
	}

	public create = async (user: User, recaptcha: string): Promise<User> => {
		const response = await this.post('/api/register', {
			user,
			recaptcha,
			'csrf-token': this.meta.getTag('name=csrf-token').content,
		})

		return this.mapToObject(response)
	}

	public sendResetPasswordEmail = async (email: string): Promise<void> => {
		await this.post(`/api/forgot-password`, {
			email,
		})
	}

	public mapToObject = (json): User => {
		return new User(
			json.id,
			json.name,
			json.email,
			Boolean(json.two_factor_confirmed_at),
			json.additional_guests,
		)
	}
}
